
import React from 'react'
import { connect } from 'react-redux'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { NotificationContainer } from 'react-notifications'
import { CircularProgress, Box } from '@material-ui/core'
// import './utils/console' /* ;) */

import TranscriptViewer from '../pages/transcript-viewer/TranscriptViewer.jsx'
import Login from '../pages/login/Login.jsx'
import PopupWrapper from '../components/popup-wrapper/PopupWrapper'
import LoadingBar from '../components/loading-bar/LoadingBar'
import * as appActions from '../store/actions/appActions'
import { routes } from './constants'

import './utils/reset.css'
import 'react-notifications/lib/notifications.css'
import './App.scss'

window.isFirstStartRuned = false;

const App = ({ firstStart, account, colorTheme, isShowFullScreenSpinner }) => {
  if (!window.isFirstStartRuned) {
    window.isFirstStartRuned = true;
    firstStart();
  }

  document.body.classList = colorTheme;

  return (
    <div>
      <Router>
        {(!account || !account.accountName || !account.passwordMD5) ? <Redirect to={routes.LOGIN} /> : null}

        <Route
          path={routes.LOGIN}
          render={routeProps => (<Login {...routeProps} />)}
        />

        <Route
          exact
          path={routes.TRANSCRIPT_VIEWER}
          render={routeProps => (<TranscriptViewer {...routeProps} />)}
        />
      </Router>
      <NotificationContainer />
      <LoadingBar />
      <PopupWrapper />
      { isShowFullScreenSpinner &&
        <Box sx={{ display: 'flex' }} className="full-screen-spinner"> <CircularProgress size="10rem" /></Box>
      }
    </div>
  )
}

App.propTypes = {
  firstStart: PropTypes.func.isRequired,
  colorTheme: PropTypes.string.isRequired,
  account: PropTypes.object.isRequired,
  isShowFullScreenSpinner: PropTypes.bool.isRequired,
};

export default connect(
  state => ({
    colorTheme: state.app.colorTheme,
    account: state.app.account,
    isShowFullScreenSpinner: state.app.isShowFullScreenSpinner,
  }),
  dispatch => bindActionCreators({
    firstStart: appActions.firstStart,
  }, dispatch),
)(App);
